// @ts-ignore
import Quill from '@cimpress-technology/quill/core';
import { JSONAttributor } from './JSONAttributor';

export const { Scope } = Quill.import('parchment');

// @ts-ignore
export default new JSONAttributor<string[]>('strokeOverprints', 'data-stroke-overprints', { scope: Scope.INLINE });
export const BlockStrokeOverprintsAttributor = new JSONAttributor<string[]>(
    // @ts-ignore
    'blockStrokeOverprints',
    'data-stroke-overprints',
    { scope: Scope.BLOCK },
);
